export const SET_ORGANISATIONS = 'dashboard/SET_ORGANISATIONS';
export const SET_ORGANISATION_TYPES = 'dashboard/SET_ORGANISATION_TYPES';
export const SET_SUPER_ACCESS_ROLES = 'dashboard/SET_SUPER_ACCESS_ROLES';
export const SET_CURRENT_USER = 'dashboard/SET_CURRENT_USER';
export const SET_CURRENCIES = 'fund/SET_CURRENCIES';
